import { AgmCoreModule, LAZY_MAPS_API_CONFIG } from '@agm/core';
import { AgmSnazzyInfoWindowModule } from '@agm/snazzy-info-window';
import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEnGB from '@angular/common/locales/extra/en-GB';
import localeEnUS from '@angular/common/locales/extra/en-US-POSIX';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { CookieLawModule } from 'angular2-cookie-law';
import { RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { SidebarModule } from 'ng-sidebar';
import { DragulaModule } from 'ng2-dragula';
import { ResponsiveModule } from 'ngx-responsive';
import { NgxSelectModule } from 'ngx-select-ex';
import { ToastrModule } from 'ngx-toastr';
import { GoogleMapsConfig } from 'src/app/modules/core/classes/GoogleMapsConfig';
import { CacheControlInterceptor } from 'src/app/modules/core/interceptors/cache-control.interceptor';
import { AppComponent } from './app.component';
import { AppRouting } from './app.routing';
import { CfeErrorHandler } from './modules/core/classes/error-handler';
import { CoreModule } from './modules/core/core.module';
import { ConfigService } from './modules/core/services/config.service';
import { FormInputModule } from './modules/forms/forms.module';
import { SharedModule } from './modules/shared/shared.module';
import { StartComponent } from './sections/start/start.component';

// Set locale
registerLocaleData(localeDe, 'de');
registerLocaleData(localeDe, 'de-DE', localeDeExtra);
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEn, 'resources');
registerLocaleData(localeEn, 'en-GB', localeEnGB);
registerLocaleData(localeEn, 'en-US', localeEnUS);

export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function init_custom_config(configService: ConfigService) {
	return () => configService.initConfig();
}

@NgModule({
	imports: [
		AppRouting,
		BrowserModule,
		CoreModule,
		DragulaModule.forRoot(),
		FormInputModule,
		SharedModule,
		BrowserAnimationsModule,
		CookieLawModule,
		NgxSelectModule,
		SidebarModule.forRoot(),
		ResponsiveModule.forRoot(),
		NgbModule,
		RecaptchaModule.forRoot(),
		RecaptchaFormsModule,
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient]
			}
		}),
		AgmCoreModule.forRoot(),
		AgmSnazzyInfoWindowModule,
		ToastrModule.forRoot({
			enableHtml: true,
			maxOpened: 3,
			positionClass: 'toast-top-center',
			preventDuplicates: true,
			resetTimeoutOnDuplicate: true,
			progressBar: true,
			timeOut: 3000
		})
	],
	providers: [
		{
			// By using token 'APP_INITIALIZER', executes this part first and waits for the function to be executed
			provide: APP_INITIALIZER,
			useFactory: init_custom_config,
			deps: [ConfigService],
			multi: true
		},
		{
			// this sets the custom key for Google maps, the key will be set if customConfig is merged
			provide: LAZY_MAPS_API_CONFIG,
			useClass: GoogleMapsConfig,
			deps: [ConfigService]
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: CacheControlInterceptor,
			multi: true
		},
		// Error handling
		{
			provide: ErrorHandler,
			useClass: CfeErrorHandler
		}
	],
	declarations: [AppComponent, StartComponent],
	bootstrap: [AppComponent]
})
export class AppModule {}
